/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
const e="ProfileGenerationError";class r extends Error{constructor(r){super("profile could not be generated"),this.cause=r,this.type=e}}function t(r){return r.type===e}export{r as ProfileGenerationError,t as isProfileGenerationError};
